import React from "react";

interface IFormRowProps {
  label: string
  minHeight?: number
  labelWidth?: number
}

class FormRow extends React.Component<React.PropsWithChildren<IFormRowProps>> {
  public render(): JSX.Element {
    const { label } = this.props;

    const width = this.props.labelWidth ? this.props.labelWidth : 125;

    return (<div className="flex gap">
      <div style={{ width, minWidth: width }}>
        {label}
      </div>
      <div className="grow1">
        {this.props.children}
      </div>
    </div>);
  }
}

export default FormRow;
